import { render, staticRenderFns } from "./diy-sheet.vue?vue&type=template&id=81e24fc6&scoped=true"
import script from "./diy-sheet.vue?vue&type=script&lang=js"
export * from "./diy-sheet.vue?vue&type=script&lang=js"
import style0 from "./diy-sheet.vue?vue&type=style&index=0&id=81e24fc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e24fc6",
  null
  
)

export default component.exports